import React from 'react';
import { ZfBox, ZfDivider, ZfStack, ZfTypography } from '@zafire/react';

type Props = {
  label: string;
  addTopMargin?: boolean;
  addBottomMargin?: boolean;
};

export const ZfDividerTitle: React.FC<Props> = ({ label, addTopMargin = false, addBottomMargin = true }) => (
  <ZfStack
    direction="row"
    alignment="center"
    spacing="extra-small"
    style={{
      marginTop: addTopMargin ? 'var(--gap-vertical-md, 16px)' : undefined,
      marginBottom: addBottomMargin ? 'var(--gap-vertical-md, 16px)' : undefined,
    }}
  >
    <ZfTypography variant="label-medium" weight="bold">
      {label}
    </ZfTypography>
    <ZfBox style={{ flex: 1 }}>
      <ZfDivider />
    </ZfBox>
  </ZfStack>
);
